import { Leaf, Heart, ShieldCheck, Users } from "lucide-react";

export default function About() {
  return (
    <div>
      <section className="bg-forest text-cream leaf-pattern">
        <div className="max-w-4xl mx-auto px-4 lg:px-8 py-16 lg:py-24 text-center">
          <span className="text-mustard font-500 text-sm uppercase tracking-wider">Our Story</span>
          <h1 className="font-heading text-4xl lg:text-6xl tracking-tight mt-2">About LIVENEAT Organic</h1>
          <p className="text-cream/80 mt-5 text-lg leading-relaxed">A curated online marketplace built on a simple belief — wellness begins with what you choose to consume. We bring you organic, natural and functional products that make healthy living effortless.</p>
        </div>
      </section>
      <div className="max-w-6xl mx-auto px-4 lg:px-8 py-14">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {[[Leaf, "Organic First", "Every product is thoughtfully sourced from trusted organic farms and makers."],
            [ShieldCheck, "Certified Quality", "FSSAI, USDA and India Organic certified products you can trust."],
            [Heart, "Wellness-Focused", "Curated around real wellness goals, not just trends."],
            [Users, "Community-Driven", "Backed by expert consultants and a growing wellness community."]].map(([Ic, t, d], i) => (
            <div key={i} className="bg-white rounded-2xl soft-shadow p-6">
              <span className="w-12 h-12 rounded-2xl bg-sage/20 flex items-center justify-center mb-4"><Ic className="w-6 h-6 text-forest" /></span>
              <h3 className="font-heading text-2xl text-forest">{t}</h3>
              <p className="text-sm text-brown/70 mt-2">{d}</p>
            </div>
          ))}
        </div>
        <div className="mt-14 bg-sand rounded-[28px] p-8 lg:p-14 text-center">
          <h2 className="font-heading text-3xl lg:text-5xl text-forest tracking-tight">LIVE BETTER. EAT BETTER. CHOOSE ORGANIC.</h2>
          <p className="text-brown/70 mt-4 max-w-2xl mx-auto">We're on a mission to make organic wellness accessible, vibrant and part of everyday life for every family.</p>
        </div>
      </div>
    </div>
  );
}
